import React, { useState } from 'react';
import {Button} from "../../elements/Button/Button";
import {TextField} from "../../elements/TextField/TextField";
import {Headings} from "../../elements/Headings/Headings";
import {ElementLink} from "../../elements/Link/Link";
import {ElementTable} from "../../elements/Table/Table";
import {Paragraph} from "../../elements/Paragraph/Paragraph";

import './TrackOrder.scss';

export const EcommTrackOrder = ({ title, description, buttonText, clickEvent, orderData }) => {
    const [orderid, setOrderid] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();

        if (orderid.trim() !== '') {
            setSubmitted(true);
            if(clickEvent) {
                clickEvent(orderid);
            }
        }
    };

    const handleChange = (event) => {
        setOrderid(event.target.value);
        if (submitted) {
            setSubmitted(false);
        }
    };

    return (
        <div className="track-your-order" x-data="trackorder">
            <div className={'section-top'}>
                <Headings text={title} type={'h2'} />
                {description && <Paragraph text={description} />}
            </div>

            <form className="track-your-order__inputs" onSubmit={handleSubmit} method={'GET'}>
                <TextField id={'postcode'} placeholder={'Order number'} value={orderid} onChange={handleChange} />
                {buttonText && <Button reverse={true} text={true} label={buttonText} onClick={() => clickEvent(orderid)}/>}
            </form>

            {submitted && orderData && (
                <div className={'track-your-order__details__container'}>
                    <hr className={'my-4'}/>
                    <div className={'track-your-order__details'}>
                        <Paragraph text={`<strong>Order Number:</strong> ${ orderData.name }`}/>
                        <ElementTable data={[
                            {Method: orderData.delivery_type, Company: orderData.tracking.company, Number: orderData.tracking.number},
                        ]}/>

                        <p>
                            Please click <ElementLink link={orderData.tracking.url} text={'Here'} new_tab={true}/> to view status updates
                        </p>
                    </div>
                </div>
            )}

            {submitted && !orderData && (
                <div className="errors">No order or tracking information was found with that ID.</div>
            )}
        </div>
    );
};
